import { Badge, type BadgeTone } from '../../components/ui/badge.js';
import type { HotelMedia } from './api.js';
import { COMPLIANCE_STATUS_LABEL, WARNING_BADGE_LABEL } from './media-compliance-copy.js';

/** Which chip colour a given warning code gets. */
const WARNING_TONE: Record<string, BadgeTone> = {
  ai_labelling_required: 'ai',
  ai_unknown: 'ai',
  ai_change_note_fttv: 'ai',
  // Sárga, nem AI-kék: itt nem AI-tényt közlünk, hanem egy ütköző adatpárt,
  // amit valakinek rendeznie kell.
  ai_contradiction: 'warn',
  gps_present: 'info',
};

/**
 * The compliance-status badges for one image: an AI/GPS warning chip per
 * entry in `media.warnings`, plus — only when the image is not attachable —
 * one status chip telling apart "unknown, needs triage" from "blocked,
 * hard no". A fully clean, attachable image with no warnings renders no
 * badge at all (empty container), matching the plain grid look today's
 * gallery already has for ordinary photos.
 */
export function MediaBadges({ media }: { media: HotelMedia }) {
  const badges: { key: string; label: string; tone: BadgeTone }[] = [];

  if (!media.attachable) {
    if (media.complianceStatus === 'unknown') {
      badges.push({ key: 'status', label: COMPLIANCE_STATUS_LABEL.unknown, tone: 'warn' });
    } else if (media.complianceStatus === 'blocked') {
      badges.push({ key: 'status', label: COMPLIANCE_STATUS_LABEL.blocked, tone: 'danger' });
    }
  }

  for (const warning of media.warnings) {
    const label = WARNING_BADGE_LABEL[warning];
    if (!label) continue;
    badges.push({ key: warning, label, tone: WARNING_TONE[warning] ?? 'neutral' });
  }

  return (
    <div className="flex flex-wrap gap-1">
      {badges.map((b) => (
        <Badge key={b.key} tone={b.tone}>
          {b.label}
        </Badge>
      ))}
    </div>
  );
}
